import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import SearchForm from "./CourseSearchForm";
import DataTable from "../../../features/DataTable";
import { getCourseList } from "../../../../services/apiCourseApplicant";
import styles from "../../../layout/admin/Main.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import { getImageUrlStr } from "../../../../utils/courseData";
import CourseApplicantUploadModal from "./CourseApplicantUploadModal";
import UnitModal from "./UnitModal";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
import { useAuth } from "../../../../contexts/AuthContext";
import CSVDownloader from "../../../ui/CSVDownloader";
import Button from "../../../ui/Button";
import { getCsvJson } from "../../../../utils/csvJson";
import { AUTH_SHIBUYA, OLD_SITE_ID, SITE_ID } from "../../../../utils/config";

const tableMeata = [
  { key: "course_name", label: "講座名" },
  { key: "c_num", label: "申込者数" },
  { key: "organ", label: "実施機関" },
  { key: "period_f", label: "申込期間(FROM)" },
  { key: "period_t", label: "申込期間(TO)" },
  { key: "period", label: "講座開催日・講座時間" },
  { key: "image", label: "画像URL" },
];

const csvItems = {
  course_name: "講座名",
  organ: "実施機関",
  period_f: "申込期間(FROM)",
  period_t: "申込期間(TO)",
  period: "講座開催日・講座時間",
  c_num: "申込者数",
  image: "画像URL",
};

const Course = () => {
  // ユーザー情報
  const { user } = useAuth();
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 一覧データ
  const [tableData, setTableData] = useState([]);
  const [tableSortData, setTableSortData] = useState([]);
  // ローディング表示
  const [loading, setLoading] = useState(false);
  // CSVダウンロード用データ
  const [csvData, setCsvData] = useState({});
  // CSVダウンロードボタン非活性フラグ
  const [isDisabled, setIsDisabled] = useState(true);
  // データテーブルリセット
  const tableResetRef = useRef();
  // csvアップロードモーダル表示ステータス
  const [showUploadModalFlag, setShowUploadModalFlag] = useState(false);
  // 合計単位数モーダル表示ステータス
  const [showUnitModalFlag, setShowUnitModalFlag] = useState(false);

  // csvアップロードモーダル表示
  const showUploadModal = () => {
    setShowUploadModalFlag(true);
  };

  // 合計単位数モーダル表示
  const showUnitModal = () => {
    setShowUnitModalFlag(true);
  };

  useEffect(() => {
    // 一覧データ初期化
    setTableData([]);
    setTableSortData([]);
    // ローディング表示開始
    setLoading(true);
    // CSVダウンロードボタンを非活性状態
    setIsDisabled(true);
    // デフォルトCSVデータ
    let csvData = [
      getCsvJson(csvItems, {
        course_name: "",
        organ: "",
        period_f: "",
        period_t: "",
        period: "",
        image: "",
      }),
    ];

    (async function () {
      if (
        searchCondition.control == undefined ||
        searchCondition.control == "1"
      ) {
        // 公開講座情報取得
        const data = await getCourseList(searchCondition);
        if (data == undefined || !data) return;
        if (data.data_list.length > 0) {
          // 一覧データ作成
          const tableData = data.data_list.map((d) => {
            return {
              key: d.course_id,
              course_name: (
                <Link to={"/admin/course/detail/" + d.id + "/" + 1}>
                  {d.course_name}
                </Link>
              ),
              c_num: d.c_num,
              organ: d.organ,
              period_f: d.period_f,
              period_t: d.period_t,
              period: d.period,
              image: (
                <a href={d.image} target="_blank" rel="noopener noreferrer">
                  {d.image}
                </a>
              ),
            };
          });
          // 一覧データセット
          setTableData(tableData);
          setTableSortData(
            data.data_list.map((d) => {
              return {
                key: d.course_id,
                course_name: d.course_name,
                c_num: d.c_num,
                organ: d.organ,
                period_f: d.period_f,
                period_t: d.period_t,
                period: d.period,
                image: d.image,
              };
            }),
          );
          //ページネーション・ソートをリセット
          tableResetRef.current?.click();

          // CSVデータ作成
          csvData = data.data_list.map((d) => {
            const csvJson = {
              course_name: d.course_name,
              organ: d.organ,
              period_f: d.period_f,
              period_t: d.period_t,
              period: d.period,
              c_num: d.c_num,
              image: d.image,
            };
            return getCsvJson(csvItems, csvJson);
          });
        }
        // CSVデータセット
        setCsvData(csvData);
      } else {
        // 非公開講座情報取得
        // 一覧データ
        let setData = [];
        let sortData = [];
        // CSVデータ
        let csvSetData = [];

        // ------サイトid = 4 の講座一覧取得開始------
        for (let i = 0; i < 1000; i++) {
          const data = await getCourseList(searchCondition, i, OLD_SITE_ID);
          if (data == undefined || !data) return;
          if (data.is_end || !data.data_list) {
            // 検索条件に関わらず1件もAPIからデータが取得できなくなった場合
            break;
          }
          if (data.data_list.length > 0) {
            // 一覧データ作成
            const addData = data.data_list.map((d) => {
              // 画像URLセット
              const image_urls = getImageUrlStr(d.image);
              return {
                key: d.course_id,
                course_name: (
                  <Link to={"/admin/course/detail/" + d.id + "/" + 1}>
                    {d.course_name}
                  </Link>
                ),
                c_num: d.c_num,
                organ: d.organ,
                period_f: d.period_f,
                period_t: d.period_t,
                period: d.period,
                image: (
                  <a
                    href={image_urls}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {image_urls}
                  </a>
                ),
              };
            });
            // 一覧データセット
            setData = setData.concat(addData);
            setTableData(setData);
            const temp = data.data_list.map((d) => {
              return {
                key: d.course_id,
                course_name: d.course_name,
                c_num: d.c_num,
                organ: d.organ,
                period_f: d.period_f,
                period_t: d.period_t,
                period: d.period,
                image: getImageUrlStr(d.image),
              };
            });
            sortData = [...sortData, ...temp];
            setTableSortData(sortData);

            //ページネーション・ソートをリセット
            tableResetRef.current?.click();

            // CSVデータ作成
            const addCsvData = data.data_list.map((d) => {
              const csvJson = {
                course_name: d.course_name,
                organ: d.organ,
                period_f: d.period_f,
                period_t: d.period_t,
                period: d.period,
                c_num: d.c_num,
                image: getImageUrlStr(d.image),
              };
              return getCsvJson(csvItems, csvJson);
            });
            // CSVデータ更新
            csvSetData = csvSetData.concat(addCsvData);
          }
        }

        // ------サイトid = 11 の講座一覧取得開始------
        for (let i = 0; i < 1000; i++) {
          const data = await getCourseList(searchCondition, i, SITE_ID);
          if (data == undefined || !data) return;
          if (data.is_end || !data.data_list) {
            // 検索条件に関わらず1件もAPIからデータが取得できなくなった場合
            break;
          }
          if (data.data_list.length > 0) {
            // 一覧データ作成
            const addData = data.data_list.map((d) => {
              // 画像URLセット
              const image_urls = getImageUrlStr(d.image);
              return {
                key: d.course_id,
                course_name: (
                  <Link to={"/admin/course/detail/" + d.id + "/" + 1}>
                    {d.course_name}
                  </Link>
                ),
                c_num: d.c_num,
                organ: d.organ,
                period_f: d.period_f,
                period_t: d.period_t,
                period: d.period,
                image: (
                  <a
                    href={image_urls}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {image_urls}
                  </a>
                ),
              };
            });
            // 一覧データセット
            setData = setData.concat(addData);
            setTableData(setData);
            const temp = data.data_list.map((d) => {
              return {
                key: d.course_id,
                course_name: d.course_name,
                c_num: d.c_num,
                organ: d.organ,
                period_f: d.period_f,
                period_t: d.period_t,
                period: d.period,
                image: getImageUrlStr(d.image),
              };
            });
            sortData = [...sortData, ...temp];
            setTableSortData(sortData);

            // CSVデータ作成
            const addCsvData = data.data_list.map((d) => {
              const csvJson = {
                course_name: d.course_name,
                organ: d.organ,
                period_f: d.period_f,
                period_t: d.period_t,
                period: d.period,
                c_num: d.c_num,
                image: getImageUrlStr(d.image),
              };
              return getCsvJson(csvItems, csvJson);
            });
            // CSVデータ更新
            csvSetData = csvSetData.concat(addCsvData);
          }
        }

        // CSVデータセット
        if (csvSetData.length > 0) {
          setCsvData(csvSetData);
        } else {
          setCsvData(csvData);
        }
      }

      // ローディング表示終了
      setLoading(false);
      // CSVダウンロードボタンを活性状態
      setIsDisabled(false);
    })();
    // 初期値をとってくる
  }, [searchCondition]);
  return (
    <div className={styles.main}>
      <ScreenTitle>講座管理</ScreenTitle>
      <>
        {user.authority == AUTH_SHIBUYA ? (
          <div className={styles.buttonbox__left}>
            <Button styleType="new" onClick={() => showUploadModal()}>
              CSVアップロード
            </Button>
          </div>
        ) : (
          <></>
        )}
      </>
      <SearchForm setSearchCondition={setSearchCondition} />
      <DataTable
        tableData={tableData}
        tableMeata={tableMeata}
        tableSortData={tableSortData}
        tableResetRef={tableResetRef}
      />
      <div className={styles.buttonbox__left}>
        <CSVDownloader
          data={csvData}
          filenameprefix="講座一覧"
          buttonname="ダウンロード"
          isDisabled={isDisabled}
          disabledText="CSVデータ作成中"
        />
        {user.authority == AUTH_SHIBUYA ? (
          <Button onClick={() => showUnitModal()} styleType="new">
            単位数集計
          </Button>
        ) : (
          <></>
        )}
      </div>
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
      {loading ? <Loading /> : <></>}
      {loading ? <Progress /> : <></>}
      <CourseApplicantUploadModal
        showFlag={showUploadModalFlag}
        setShowModal={setShowUploadModalFlag}
        key={showUploadModalFlag}
      />
      <UnitModal
        showFlag={showUnitModalFlag}
        setShowModal={setShowUnitModalFlag}
        key={showUnitModalFlag}
      />
    </div>
  );
};
export default Course;
